import React from 'react';
import CustomSelectFieldNGX from "./CustomSelectFieldNGX";
import CustomTextFieldNGX from "./CustomTextFieldNGX";
import CustomDatePickerFieldNGX from "./CustomDatePickerFieldNGX";
import rulesText from '../Entity/rulesText';
import ValidatorInputText from '../Module/Validatoren/ValidatorInputText';
import CreatureConfigDialog from './CreatureConfigDialog';


import Grid from '@mui/material/Grid';
import Zoom from '@mui/material/Zoom';
import Collapse from '@mui/material/Zoom';

import Button from '@mui/material/Button';

import Spezies from './Spezies';
import FotosUploader from '../Containers/FotosUploader';
import DokumenteUploader from '../Containers/DokumenteUploader';

import HilfeRingnummer from "./Hilfe/Creature/HilfeRingnummer";
import HilfeRingSonderfall from "./Hilfe/Creature/HilfeRingSonderfall";
import HilfeFotodokumentationArtenschutz from "./Hilfe/Creature/HilfeFotodokumentationArtenschutz";

import {speziesSetzen, anzahlSpeziesSetzen} from '../Actions';
import {Standard as StandardDataField} from "../Entity/Kennzeichnung/StandardDataFields";

const Creature = (props) => {

  return (

    <div>

      {props.creature.hasOwnProperty("spezies") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} style={{marginBottom:"19px"}}>
              <Spezies
                spezies={props.creature.spezies}
                anzahl={props.creature.anzahl}
                zeigeAnzahl={props.creature.zeigeAnzahl}
                restLadeSpezies={props.restLadeSpezies}
                dispatchSpezies = {
                  (obj)=>{
                    let pathSpecies = props.creaturePath
                    pathSpecies.push('spezies')

                    props.dispatch(
                      speziesSetzen(
                        obj,
                        pathSpecies
                      )
                    )
                  }
                }
                dispatchAnzahl = {
                  (anzahl)=>props.dispatch(
                    anzahlSpeziesSetzen(
                      anzahl,
                      props.creaturePath
                    )
                  )
                }
                updaterTouched={props.updaterTouch('spezies')}
              />
            </Grid>
          </Grid>
        </Zoom>
      }
      

      {props.creature.anzahl > 1 &&
        <Collapse 
          in={props.creature.anzahl > 1}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <div style={{marginBottom:"20px"}}>
            Sie beschreiben mehr als ein Exemplar. Beschreibung als Gruppe aktivieren? 
            {props.creature.hasOwnProperty("geschlecht") &&
            <Button
              onClick={
                ()=>{
                  props.removeEntity("geschlecht")
                  props.removeEntity("rufname")
                  props.addEntity("anzahlMale", StandardDataField())
                  props.addEntity("anzahlFemale", StandardDataField())
                  props.addEntity("anzahlGenderUnknown", StandardDataField())
                }
              }
            >
              Gruppenbeschreibung aktivieren
            </Button>
            }
            {props.creature.hasOwnProperty("anzahlMale") &&
            <Button
              onClick={
                ()=>{
                  props.removeEntity("anzahlMale")
                  props.removeEntity("anzahlFemale")
                  props.removeEntity("anzahlGenderUnknown")
                  props.addEntity("geschlecht", StandardDataField())
                  props.addEntity("rufname", StandardDataField())
                }
              }
            >
              Gruppenbeschreibung deaktivieren
            </Button>
            }
          </div>
        </Collapse>
      }

      <Grid container spacing={2}>

      {props.creature.hasOwnProperty("anzahlMale") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid item xs={2}>
            <CustomTextFieldNGX
              id={props.creature.uniqueId+"-menge-male"}
              label="Anzahl männlicher Exemplare"
              data={props.creature.anzahlMale}
              updaterValue={props.updaterValue('anzahlMale')}
              updaterTouch={props.updaterTouch('anzahlMale')}
              required={false}
              validator={
                  () => ValidatorInputText(
                    props.creature.anzahlMale.value,
                    rulesText(true,1)
                  )
              }
              inputProps={{ 'aria-label': 'Anzahl männlicher Exemplare' }}
            />
          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("anzahlFemale") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid item xs={2}>
            <CustomTextFieldNGX
              id={props.creature.uniqueId+"-menge-female"}
              label="Anzahl weiblicher Exemplare"
              data={props.creature.anzahlFemale}
              updaterValue={props.updaterValue('anzahlFemale')}
              updaterTouch={props.updaterTouch('anzahlFemale')}
              required={true}
              validator={
                  () => ValidatorInputText(
                    props.creature.anzahlFemale.value,
                    rulesText(true,1)
                  )
              }
              inputProps={{ 'aria-label': 'Anzahl weiblicher Exemplare' }}
            />
          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("anzahlGenderUnknown") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid item xs={2}>
            <CustomTextFieldNGX
              id={props.creature.uniqueId+"-menge-unknown"}
              label="Anzahl Exemplare unbekannten Geschlechts"
              data={props.creature.anzahlGenderUnknown}
              updaterValue={props.updaterValue('anzahlGenderUnknown')}
              updaterTouch={props.updaterTouch('anzahlGenderUnknown')}
              required={true}
              validator={
                  () => ValidatorInputText(
                    props.creature.anzahlGenderUnknown.value,
                    rulesText(true,1)
                  )
              }
              inputProps={{ 'aria-label': 'Anzahl Exemplare unbekannten Geschlechts' }}
            />
          </Grid>
        </Zoom>
      }

        {props.creature.hasOwnProperty('geschlecht') &&

          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >

            <Grid item lg={3} md={6} xs={12}>
              <CustomSelectFieldNGX
                id={props.creature.uniqueId+"-geschlecht"}
                label="Geschlecht"
                value={props.creature.geschlecht.value}
                updaterValue={props.updaterValue('geschlecht')}
                touched={props.creature.geschlecht.touched}
                updaterTouch={props.updaterTouch('geschlecht')}
                updaterValid={props.updaterValid('geschlecht')}
                list={[
                    {
                      id:'weiblich',
                      label:'weiblich',
                    },
                    {
                      id:'maennlich',
                      label:'männlich',
                    },
                    {
                      id:'unbekannt',
                      label:'unbekannt',
                  }    
                ]}
              />

            </Grid>        
          </Zoom>
        }

        {props.creature.hasOwnProperty("rufname") &&
          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >
            <Grid item lg={3} md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-rufname"}
                label="Rufname"
                data={props.creature.rufname}
                updaterValue={props.updaterValue('rufname')}
                updaterTouch={props.updaterTouch('rufname')}
                required={false}
                validator={
                    () => ValidatorInputText(
                      props.creature.rufname.value,
                      rulesText(false,1)
                    )
                }
                inputProps={{ 'aria-label': 'Rufname des Exemplars' }}
              />
            </Grid>
          </Zoom>
        }

        {props.creature.hasOwnProperty("geburtsdatum") &&
          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >

            <Grid item lg={3} md={6} xs={12}>
              <CustomDatePickerFieldNGX
                id={props.creature.uniqueId+"-geburtsdatum"}
                label="Geburtsdatum"
                value={props.creature.geburtsdatum.value}
                updaterValue={props.updaterValue('geburtsdatum')}
                updaterTouch={props.updaterTouch('geburtsdatum')}
                ariaLabel="Geburtsdatum ändern"
              />
            </Grid>
          </Zoom>
        }

        {props.creature.hasOwnProperty("geburtsdatum") &&
          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >

            <Grid item lg={3} md={6} xs={12}>
              <CustomSelectFieldNGX
                id={props.creature.uniqueId+"-geburtsdatumZusatz"}
                label="Geburtsdatum Zusatz"
                value={props.creature.geburtsdatumZusatz.value}
                updaterValue={props.updaterValue('geburtsdatumZusatz')}
                touched={props.creature.geburtsdatumZusatz.touched}
                updaterTouch={props.updaterTouch('geburtsdatumZusatz')}
                updaterValid={props.updaterValid('geburtsdatumZusatz')}
                list={[
                  {
                    id:'aufTagGenau',
                    label:'Auf den Tag genau',
                  },
                  {
                    id:'vorDatum',
                    label:'Liegt vor angegebenen Datum',
                  },
                  {
                    id:'nachDatum',
                    label:'Liegt nach angegebenen Datum',
                  },
                  {
                    id:'aufMonatGenau',
                    label:'Auf den Monat genau',
                  },
                  {
                    id:'aufJahrGenau',
                    label:'Auf das Jahr genau',
                  },
                  {
                    id:'geschaetzt',
                    label:'geschätzt',
                  },
                  {
                    id:'unbekannt',
                    label:'unbekannt',
                  },
                ]}
              />

            </Grid>

          </Zoom>
        }

        {props.creature.hasOwnProperty("datumBesitzSeit") &&
          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >
              <Grid item lg={3} md={6} xs={12}>
                <CustomDatePickerFieldNG
                  id={props.creature.uniqueId+"-datumBesitzSeit"}
                  label="Besitz seit"
                  value={props.creature.datumBesitzSeit.value}
                  updaterValue={props.updaterValue('datumBesitzSeit')}
                  updaterTouch={props.updaterTouch('datumBesitzSeit')}
                  ariaLabel="Datum des Besitzes seit angeben"
                />
              </Grid>
          </Zoom>
        }

        {props.creature.hasOwnProperty("meldeid") &&
          <Zoom 
            in={true}
            timeout={500}
            style={{ transitionDelay: '10ms' }}
          >
            <Grid item lg={3} md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-medldeid"}
                label="Meldenummer"
                data={props.creature.meldeid}
                updaterValue={props.updaterValue('meldeid')}
                updaterTouch={props.updaterTouch('meldeid')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.meldeid.value,
                      rulesText(false,2)
                    )
                }
                inputProps={{ 'aria-label': 'Meldenummer' }}
              />
            </Grid>
          </Zoom>
        }

      </Grid>{/* /container */}


      {props.creature.hasOwnProperty("ringtyp") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid container spacing={2} style={{marginTop:"0px"}}>
            <Grid item md={6} xs={12}>

              <CustomSelectFieldNGX
                id={props.creature.uniqueId+"-ringtyp"}
                label="Ringtyp"
                value={props.creature.ringtyp.value}
                updaterValue={
                  (value)=>{
                    props.updaterValue('ringtyp')(value)
                    if (value == "istSonderfall") {
                      props.addEntity("ringkommentar", StandardDataField())
                    } else {
                      props.removeEntity("ringkommentar")
                    }
                  }
                }
                touched={props.creature.ringtyp.touched}
                updaterTouch={props.updaterTouch('ringtyp')}
                updaterValid={props.updaterValid('ringtyp')}
                list={[
                  {
                    id:'istRingGeschlossen',
                    label:'Geschlossener Ring',
                  },
                  {
                    id:'istSonderfall',
                    label:'Anderer Ringtyp oder Ring nicht angelegt',
                  },
                ]}
              />
            </Grid>

            {props.creature.hasOwnProperty("ringnummer") &&
            <Grid item md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-ringnummer"}
                label="Ringnummer"
                data={props.creature.ringnummer}
                updaterValue={props.updaterValue('ringnummer')}
                updaterTouch={props.updaterTouch('ringnummer')}
                required={props.creature.ringtyp.value == "istRingGeschlossen"?true:false}
                validator={
                  () => {
                    if (props.creature.ringtyp.value == "istRingGeschlossen") {
                      return ValidatorInputText(
                        props.creature.ringnummer.value,
                        rulesText(true,5)
                      )
                    }
                    return ValidatorInputText(
                      props.creature.ringnummer.value,
                      rulesText(false,5)
                    )
                  }
                }
                inputProps={{ 'aria-label': 'Ringnummer' }}
              />
            </Grid>
            }

            {props.creature.hasOwnProperty("ringkommentar") &&
              <Grid item xs={12}>
                <HilfeRingSonderfall/>
              </Grid>
            }
            {props.creature.hasOwnProperty("ringkommentar") &&
              <Grid item xs={12}>
                <CustomTextFieldNGX
                  id={props.creature.uniqueId+"-ringkommentar"}
                  label="Begründung für anderen oder fehlenden Ring"
                  data={props.creature.ringkommentar}
                  updaterValue={props.updaterValue('ringkommentar')}
                  updaterTouch={props.updaterTouch('ringkommentar')}
                  required={true}
                  validator={
                      () => ValidatorInputText(
                        props.creature.ringkommentar.value,
                        rulesText(true,5)
                      )
                  }
                  inputProps={{ 'aria-label': 'Begründung für anderen oder fehlenden Ring' }}
                />
              </Grid>
            }

            <Grid item xs={12}>
              <HilfeRingnummer/>
            </Grid> 

          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("microchip") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid container spacing={2} style={{marginTop:"0px"}}>
            <Grid item xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-microchip"}
                label="Transponder/Microchip"
                data={props.creature.microchip}
                updaterValue={props.updaterValue('microchip')}
                updaterTouch={props.updaterTouch('microchip')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.microchip.value,
                      rulesText(true,2)
                    )
                }
                inputProps={{ 'aria-label': 'Transponder/Microchip Nummer' }}
              />
            </Grid>
          </Grid>
        </Zoom>
      }


      {props.creature.hasOwnProperty("andereKennzeichnungArt") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid container spacing={2} style={{marginTop:"0px"}}>
            <Grid item md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-andereKennzeichnungArt"}
                label="Art der Kennzeichnung"
                data={props.creature.andereKennzeichnungArt}
                updaterValue={props.updaterValue('andereKennzeichnungArt')}
                updaterTouch={props.updaterTouch('andereKennzeichnungArt')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.andereKennzeichnungArt.value,
                      rulesText(true,2)
                    )
                }
                inputProps={{ 'aria-label': 'Art der Kennzeichnung' }}
              />
            </Grid>

            <Grid item md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-andereKennzeichnungBeschreibung"}
                label="Beschreibung der Kennzeichnung"
                data={props.creature.andereKennzeichnungBeschreibung}
                updaterValue={props.updaterValue('andereKennzeichnungBeschreibung')}
                updaterTouch={props.updaterTouch('andereKennzeichnungBeschreibung')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.andereKennzeichnungBeschreibung.value,
                      rulesText(true,2)
                    )
                }
                inputProps={{ 'aria-label': 'Beschreibung der Kennzeichnung' }}
              />
            </Grid>
          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("zuchtbuchNummerDesBuches") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >

          <Grid container spacing={2} style={{marginTop:"0px"}}>
            <Grid item md={6} xs={12}>

              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-zuchtbuchNummerDesBuches"}
                label="Nummer des Zuchtbuches"
                data={props.creature.zuchtbuchNummerDesBuches}
                updaterValue={props.updaterValue('zuchtbuchNummerDesBuches')}
                updaterTouch={props.updaterTouch('zuchtbuchNummerDesBuches')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.zuchtbuchNummerDesBuches.value,
                      rulesText(true,1)
                    )
                }
                inputProps={{ 'aria-label': 'Nummer des Zuchtbuches' }}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <CustomTextFieldNGX
                id={props.creature.uniqueId+"-zuchtbuchNummerDesTieres"}
                label="Nummer des Exemplars"
                data={props.creature.zuchtbuchNummerDesTieres}
                updaterValue={props.updaterValue('zuchtbuchNummerDesTieres')}
                updaterTouch={props.updaterTouch('zuchtbuchNummerDesTieres')}
                required={true}
                validator={
                    () => ValidatorInputText(
                      props.creature.zuchtbuchNummerDesTieres.value,
                      rulesText(true,1)
                    )
                }
                inputProps={{ 'aria-label': 'Nummer des Exemplars im Zuchtbuch' }}
              />
            </Grid>
          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("fotodokumentation") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >

          <div style={{paddingTop:"20px",paddingBottom:"20px"}}>
            <FotosUploader
              fotos={props.creature.fotodokumentation}
              restPath={props.restPath}
              dispatch={props.dispatch}
              lineage={[...props.creaturePath, 'fotodokumentation']}
              hilfe={<HilfeFotodokumentationArtenschutz/>}
            />
          </div>
        </Zoom>
      }

      {(props.creature.hasOwnProperty("gewicht") || props.creature.hasOwnProperty("groesse")) &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <Grid container spacing={2} style={{marginTop:"0px"}}>
            
            {props.creature.hasOwnProperty("gewicht") &&
              <Grid item xs={6}>
                <CustomTextFieldNGX
                  id={props.creature.uniqueId+"-gewicht"}
                  label="Gewicht in Gramm"
                  endAdornment="g"
                  data={props.creature.gewicht}
                  updaterValue={props.updaterValue('gewicht')}
                  updaterTouch={props.updaterTouch('gewicht')}
                  required={true}
                  validator={
                      () => ValidatorInputText(
                        props.creature.gewicht.value,
                        rulesText(false,0)
                      )
                  }
                  inputProps={{ 
                    'aria-label': 'Gewicht in Gramm',
                  }}
                />
              </Grid>
            }
            {props.creature.hasOwnProperty("groesse") &&
              <Grid item xs={6}>
                <CustomTextFieldNGX
                  id={props.creature.uniqueId+"-groesse"}
                  label="Größe in cm"
                  endAdornment="cm"
                  data={props.creature.groesse}
                  updaterValue={props.updaterValue('groesse')}
                  updaterTouch={props.updaterTouch('groesse')}
                  required={false}
                  validator={
                      () => ValidatorInputText(
                        props.creature.groesse.value,
                        rulesText(false,0)
                      )
                  }
                  inputProps={{ 'aria-label': 'Transponder/Microchip Nummer' }}
                />
              </Grid>
            }
          </Grid>
        </Zoom>
      }

      {props.creature.hasOwnProperty("dokumente") &&
        <Zoom 
          in={true}
          timeout={500}
          style={{ transitionDelay: '10ms' }}
        >
          <div style={{paddingBottom:"20px"}}>
            <DokumenteUploader
              dokumente={props.creature.dokumente}
              restPath={props.restPath}
              dispatch={props.dispatch}
              lineage={[...props.creaturePath, 'dokumente']}
            />
          </div>
        </Zoom>
      }

      <CreatureConfigDialog 
        creature={props.creature} 
        addEntity={props.addEntity}
        removeEntity={props.removeEntity}
        updaterValueAnzahl={
          (anzahl)=>props.dispatch(
            anzahlSpeziesSetzen(
              anzahl,
              props.creaturePath
            )
          )
        }
      />

    </div>
    
  )
}

export default Creature;
